import { useTranslation } from 'react-i18next';
import Tag from './Tag';

const RenderPaymentStatusTag = ({ type, step, className }) => {
  const { t } = useTranslation();
  switch (step) {
    case 0:
      return (
        <Tag
          className={`flex py-[4px] px-[8px] items-center gap-[6px] rounded-[1000px] bg-[#F97D16] ${className}`}
          label={
            <span className="text-label-medium font-semibold text-white">
              {t('Pending payment')}
            </span>
          }
        />
      );
    case 1:
      return (
        <Tag
          className={`flex py-[4px] px-[8px] items-center gap-[6px] rounded-[1000px] bg-[#258FD2] ${className}`}
          label={
            <span className="text-label-medium font-semibold text-white">
              {t('Paid first time')}
            </span>
          }
        />
      );
    case 2:
      return (
        <Tag
          className={`flex py-[4px] px-[8px] items-center gap-[6px] rounded-[1000px] bg-[#258FD2] ${className}`}
          label={
            <span className="text-label-medium font-semibold text-white">
              {t('Paid second time')}
            </span>
          }
        />
      );
    case 3:
      return (
        <Tag
          className={`flex py-[4px] px-[6px] items-center gap-[6px] rounded-[1000px] bg-[#49AC3E] ${className}`}
          label={
            <span className="text-label-medium font-semibold text-white">
              {t('Completed payment')}
            </span>
          }
        />
      );
    default:
      return <></>;
  }
};

export default RenderPaymentStatusTag;
